import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["container", "expandable"];
  static values = { commentorId: Number };

  toggle(event) {
    event.preventDefault();

    if (!this.containerTarget.classList.contains("collapsed")) {
      // TODO Don't click if there is something in the textarea

      const elements = document.querySelectorAll(`[data-suggest-reply-for-commentor-id="${this.commentorIdValue}"]`);
      const textareas = document.querySelectorAll(`[data-textarea-for-commentor-id="${this.commentorIdValue}"]`);

      if (elements.length == 1 && textareas.length == 1 && textareas[0].value == "") {
        elements[0].click();
      }
    }

    this.expandableTarget.classList.toggle("d-none");
    this.expandableTarget.classList.toggle("bg-gray-200");
    this.containerTarget.classList.toggle("bg-gray-200");
    this.containerTarget.classList.toggle("collapsed");
  }
}
